/**
 * Gift Card Balance Checker
 * Handles gift card balance lookup functionality
 */

class GiftCardBalance {
  constructor() {
    // Check if there's a custom API URL set in the theme settings
    const apiUrlElement = document.querySelector('[data-api-url]');
    this.apiUrl = apiUrlElement ? apiUrlElement.dataset.apiUrl : 'https://americansale.empistdev.com/gift-card-balance/';
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.bindEvents());
    } else {
      this.bindEvents();
    }
  }

  bindEvents() {
    const checkBalanceBtn = document.getElementById('checkBalanceBtn');
    const resetFormBtn = document.getElementById('resetFormBtn');

    if (checkBalanceBtn) {
      checkBalanceBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.getGiftCardBalance();
      });
    }

    if (resetFormBtn) {
      resetFormBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.giftCardReset();
      });
    }

    // Allow Enter key to trigger balance check
    const giftCardNumber = document.getElementById('giftCardNumber');
    const giftCardZip = document.getElementById('giftCardZip');
    
    if (giftCardNumber) {
      giftCardNumber.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.getGiftCardBalance();
        }
      });
    }

    if (giftCardZip) {
      giftCardZip.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.getGiftCardBalance();
        }
      });
    }
  }

  /**
   * Get Gift Card Balance
   * Makes API call to check gift card balance using card number and optional zip code
   */
  getGiftCardBalance() {
    const giftCardNumberInput = document.getElementById('giftCardNumber');
    const giftCardZipInput = document.getElementById('giftCardZip');
    const formCnt = document.getElementById('formCnt');
    const resultCnt = document.getElementById('resultCnt');
    const balanceAmount = document.getElementById('balanceAmount');
    const errorMessage = document.getElementById('errorMessage');

    if (!giftCardNumberInput || !formCnt || !resultCnt) {
      console.error('Required elements not found');
      return;
    }

    const giftCardNumber = giftCardNumberInput.value.trim();
    const giftCardZip = giftCardZipInput ? giftCardZipInput.value.trim() : '';

    // Validation: Check if gift card number is provided
    if (!giftCardNumber || giftCardNumber.length === 0) {
      giftCardNumberInput.classList.add('required');
      this.showError('Please enter a gift card number');
      return;
    } else {
      giftCardNumberInput.classList.remove('required');
    }

    // Show loading state
    this.showLoading();

    // Build API URL: add zip code if provided
    const apiUrl = this.apiUrl + (giftCardZip ? `${giftCardNumber}/${giftCardZip}` : giftCardNumber);

    // Make API call to check balance
    this.makeApiCall(apiUrl)
      .then(response => {
        // Success: Display balance
        formCnt.style.display = 'none';
        if (balanceAmount) {
          balanceAmount.textContent = `$${response.balance}`;
        }
        if (errorMessage) {
          errorMessage.textContent = '';
        }
        resultCnt.style.display = 'block';
        resultCnt.style.visibility = 'visible';
        resultCnt.style.opacity = '1';
      })
      .catch(error => {
        // Error: Display not found message
        console.error('Gift card balance check failed:', error);
        formCnt.style.display = 'none';
        if (errorMessage) {
          errorMessage.textContent = 'The gift card was not found!';
        }
        if (balanceAmount) {
          balanceAmount.textContent = '';
        }
        resultCnt.style.display = 'block';
        resultCnt.style.visibility = 'visible';
        resultCnt.style.opacity = '1';
      });
  }

  /**
   * Reset Gift Card Form
   * Clears the form and results to allow checking another gift card
   */
  giftCardReset() {
    const giftCardNumberInput = document.getElementById('giftCardNumber');
    const giftCardZipInput = document.getElementById('giftCardZip');
    const formCnt = document.getElementById('formCnt');
    const resultCnt = document.getElementById('resultCnt');
    const balanceAmount = document.getElementById('balanceAmount');
    const errorMessage = document.getElementById('errorMessage');

    if (giftCardNumberInput) {
      giftCardNumberInput.classList.remove('required');
      giftCardNumberInput.value = '';
    }

    if (giftCardZipInput) {
      giftCardZipInput.value = '';
    }

    if (balanceAmount) {
      balanceAmount.textContent = '';
    }

    if (errorMessage) {
      errorMessage.textContent = '';
    }

    if (resultCnt) {
      resultCnt.style.display = 'none';
    }

    if (formCnt) {
      formCnt.style.display = 'block';
    }

    // Focus back on the gift card number input
    if (giftCardNumberInput) {
      giftCardNumberInput.focus();
    }
  }

  /**
   * Make API call with proper headers
   */
  makeApiCall(url) {
    return fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    });
  }

  /**
   * Show loading state
   */
  showLoading() {
    const checkBalanceBtn = document.getElementById('checkBalanceBtn');
    if (checkBalanceBtn) {
      checkBalanceBtn.textContent = 'Checking...';
      checkBalanceBtn.disabled = true;
    }
  }

  /**
   * Show error message
   */
  showError(message) {
    const errorMessage = document.getElementById('errorMessage');
    const formCnt = document.getElementById('formCnt');
    const resultCnt = document.getElementById('resultCnt');

    if (errorMessage) {
      errorMessage.textContent = message;
    }

    if (formCnt) {
      formCnt.style.display = 'none';
    }

    if (resultCnt) {
      resultCnt.style.display = 'block';
      resultCnt.style.visibility = 'visible';
      resultCnt.style.opacity = '1';
    }
  }
}

// Initialize the gift card balance checker when the script loads
new GiftCardBalance();
